(!(function () {
  const e = function () {
    "use strict";
    if (
      ((window.__ectimmers = window.__ectimmers || {}),
      (window.__ectimmers["ecom-9btpz51swp8"] =
        window.__ectimmers["ecom-9btpz51swp8"] || {}),
      !this.$el)
    )
      return;
    const e = this.$el,
      t = e.querySelector(".ecom-text_view-more-btn"),
      o = e.querySelector(".ecom-text_view-less-btn"),
      i = e.querySelector(".text-content.ecom-html");
    !i ||
      (t &&
        t.addEventListener("click", () => {
          (i.classList.remove("ecom-text--is-mark"),
            (i.style.maxHeight = ""),
            (t.style.display = "none"),
            (o.style.display = ""));
        }),
      o &&
        o.addEventListener("click", () => {
          (i.classList.add("ecom-text--is-mark"),
            (i.style.maxHeight = "var(--ecom-text-height)"),
            (o.style.display = "none"),
            (t.style.display = ""));
        }));
  };
  (document.querySelectorAll(".ecom-9btpz51swp8").forEach(function (t) {
    e.call({ $el: t, id: "ecom-9btpz51swp8", settings: {}, isLive: !0 });
  }),
    document.querySelectorAll(".ecom-syko97q6juk").forEach(function (t) {
      e.call({ $el: t, id: "ecom-syko97q6juk", settings: {}, isLive: !0 });
    }),
    document.querySelectorAll(".ecom-2wo5o6ao4i3").forEach(function (t) {
      e.call({ $el: t, id: "ecom-2wo5o6ao4i3", settings: {}, isLive: !0 });
    }),
    document.querySelectorAll(".ecom-5h0ml34gl8h").forEach(function (t) {
      e.call({ $el: t, id: "ecom-5h0ml34gl8h", settings: {}, isLive: !0 });
    }),
    document.querySelectorAll(".ecom-uv287bhdu8b").forEach(function (t) {
      e.call({ $el: t, id: "ecom-uv287bhdu8b", settings: {}, isLive: !0 });
    }),
    document.querySelectorAll(".ecom-jjmkp900qqd").forEach(function (t) {
      e.call({ $el: t, id: "ecom-jjmkp900qqd", settings: {}, isLive: !0 });
    }),
    document.querySelectorAll(".ecom-jf9zxbpg1hs").forEach(function (t) {
      e.call({ $el: t, id: "ecom-jf9zxbpg1hs", settings: {}, isLive: !0 });
    }),
    document.querySelectorAll(".ecom-q72igh4zxqs").forEach(function (t) {
      e.call({ $el: t, id: "ecom-q72igh4zxqs", settings: {}, isLive: !0 });
    }),
    document.querySelectorAll(".ecom-7r5eex3zv46").forEach(function (t) {
      e.call({ $el: t, id: "ecom-7r5eex3zv46", settings: {}, isLive: !0 });
    }),
    document.querySelectorAll(".ecom-1qdfaksxb6j").forEach(function (t) {
      e.call({ $el: t, id: "ecom-1qdfaksxb6j", settings: {}, isLive: !0 });
    }),
    document.querySelectorAll(".ecom-91jocwwspdp").forEach(function (t) {
      e.call({ $el: t, id: "ecom-91jocwwspdp", settings: {}, isLive: !0 });
    }),
    document.querySelectorAll(".ecom-4mbssm6byum").forEach(function (t) {
      e.call({ $el: t, id: "ecom-4mbssm6byum", settings: {}, isLive: !0 });
    }),
    document.querySelectorAll(".ecom-9xsc6idb2vg").forEach(function (t) {
      e.call({ $el: t, id: "ecom-9xsc6idb2vg", settings: {}, isLive: !0 });
    }));
})(),
  (function () {
    const e = function () {
      "use strict";
      ((window.__ectimmers = window.__ectimmers || {}),
        (window.__ectimmers["ecom-hu4mein74c"] =
          window.__ectimmers["ecom-hu4mein74c"] || {}));
      const e = this.$el;
      if (!e) return;
      const t = e.querySelector("form");
      let o = this.settings.link_redirect;
      if (this.isLive) {
        !(function () {
          if (!o) return !1;
          let e = o.href;
          if ("" == e) return !1;
          let t = o.target;
          window.location.href.includes("customer_posted=true") &&
            ("_blank" === t ? window.open(e) : (window.location.href = e));
        })();
        const i = /^(\?|&)contact%5Btags%5D=[^&]+&form_type=customer(&|$)/;
        (this.settings.scroll_in_view &&
          (window.location.pathname.includes("challenge")
            ? setTimeout(function () {
                document
                  .querySelector(".shopify-challenge__container")
                  .scrollIntoView();
              }, 100)
            : setTimeout(function () {
                (i.test(location.search) ||
                  window.location.href.includes("customer_posted=true")) &&
                  e.scrollIntoView();
              }, 300)),
          i.test(location.search) &&
            t &&
            t.querySelector(".ecom-shopify__newsletter-form-message.ecom-dn") &&
            t
              .querySelector(".ecom-shopify__newsletter-form-message.ecom-dn")
              .classList.remove("ecom-dn"),
          t &&
            t.dataset.ecTrackingId &&
            t.addEventListener(
              "submit",
              function () {
                window.Shopify &&
                  window.Shopify.analytics &&
                  Shopify.analytics.publish("ec_custom_events", {
                    button_id: t.id,
                    tracking_id: t.dataset.ecTrackingId
                  });
              },
              { once: !0 }
            ));
        let n = e.querySelector(".ecom-shopify__newsletter__verify-checkbox"),
          c = e.querySelector(".ecom-shopify__newsletter__verify-error"),
          r = e.querySelector(".ecome-shopify__newsletter__button");
        n &&
          (r.addEventListener("click", function (e) {
            0 == n.checked
              ? (e.preventDefault(), c.classList.remove("ecom-dn"))
              : c.classList.add("ecom-dn");
          }),
          n.addEventListener("change", function (e) {
            n.checked && c.classList.add("ecom-dn");
          }));
      }
    };
    document.querySelectorAll(".ecom-hu4mein74c").forEach(function (t) {
      e.call({
        $el: t,
        id: "ecom-hu4mein74c",
        settings: { scroll_in_view: !0 },
        isLive: !0
      });
    });
  })(),
  (function () {
    const e = function () {
      "use strict";
      var e, t, o, i, n, c;
      ((window.__ectimmers = window.__ectimmers || {}),
        (window.__ectimmers["ecom-ssu8aoawg4"] =
          window.__ectimmers["ecom-ssu8aoawg4"] || {}));
      let r = this.$el;
      if (!r) return;
      let s = this.isLive;
      const l = null != (e = this.settings.disable_auto_close) && e,
        a = null != (t = this.settings.disable_auto_close__tablet) && t,
        d = null != (o = this.settings.disable_auto_close__mobile) && o,
        u = null != (i = this.settings.scroll_on_mobile) && i,
        m = null != (n = this.settings.disable_effect) && n,
        p = null != (c = this.settings.close_all) && c,
        h = r.querySelectorAll(
          ".ecom-accordion__item > .ecom-accordion__title"
        );
      function f(e) {
        const t = e.getBoundingClientRect();
        return (
          t.top >= 0 &&
          t.left >= 0 &&
          t.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          t.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
      }
      function w(e) {
        let t = window.screen.width;
        (window.EComposer.TEMPLATE_ID || (t = window.innerWidth),
          e.forEach((e, o) => {
            let i = e.parentNode.querySelector(".ecom-accordion__body");
            (!m && i && i.classList.add("ecom-effect-accodion"),
              0 == o && (i.style.height = i.clientHeight + "px"),
              (e.onclick = function (o) {
                o.preventDefault();
                let i = this.parentNode,
                  n = i.parentNode;
                const c = n.querySelectorAll(".ecom-accordion__item"),
                  p = n.querySelectorAll(".ecom-accordion__title");
                if (
                  (i.classList && i.classList.remove("ecom-item-group-init"),
                  this.classList && this.classList.contains("ecom-item-active"))
                )
                  (d && t < 768) ||
                  (a && t > 767 && t < 1025) ||
                  (l && t > 1024)
                    ? (this.classList.remove("ecom-item-active"),
                      (i.querySelector(".ecom-accordion__body").style.height =
                        "0px"),
                      i
                        .querySelector(".ecom-accordion__title")
                        .classList.remove("ecom-item-active"),
                      i.classList.remove("ecom-item-active"))
                    : (c.forEach((e) => _(e)),
                      p.forEach((e) => e.classList.remove("ecom-item-active")));
                else {
                  ((d && t < 768) ||
                    (a && t > 767 && t < 1025) ||
                    (l && t > 1024) ||
                    (c.forEach((e) => _(e)),
                    p.forEach((e) => e.classList.remove("ecom-item-active"))),
                    e.classList.add("ecom-item-active"),
                    i.classList.add("ecom-item-active"));
                  let o = e.parentNode.querySelector(".ecom-accordion__body");
                  (e.parentNode.closest(".ecom-accordion__body") &&
                    (e.parentNode.closest(
                      ".ecom-accordion__body"
                    ).style.height = "auto"),
                    (o.style.height = "auto"));
                  let n = "auto";
                  (m ||
                    ((n = s ? o.clientHeight + "px" : "auto"),
                    o.classList.add("ecom-effect-accodion")),
                    (o.style.height = "0px"),
                    setTimeout(() => {
                      o.style.height = n;
                    }, 10));
                }
                function h(e) {
                  window.scroll(
                    0,
                    (function (e) {
                      let t = 0;
                      if (e.offsetParent) {
                        do {
                          t += e.offsetTop;
                        } while ((e = e.offsetParent));
                        return [t];
                      }
                    })(r) - 100
                  );
                }
                (window.dispatchEvent(new window.Event("renderScroll")),
                  setTimeout(() => {
                    (window.dispatchEvent(new window.Event("renderScroll")),
                      u ? f(this) || h() : !f(this) && t > 1024 && h());
                  }, 500));
              }));
          }));
      }
      function _(e) {
        (e.classList.remove("ecom-item-active"),
          (e.querySelector(".ecom-accordion__body").style.height = "0"));
      }
      function g() {
        let e = window.location.hash;
        if (e) {
          let t = r.querySelector(`[data-target="${e}"]`);
          if (t) {
            t.click();
            let e = new MouseEvent("mouseover", {
              bubbles: !0,
              cancelable: !0,
              view: window
            });
            t.dispatchEvent(e);
            let o =
              t.getBoundingClientRect().top +
              window.pageYOffset -
              window.innerHeight / 2;
            window.scrollTo(0, o);
          }
        }
      }
      (w(h),
        p ||
          setTimeout(() => {
            r.querySelector(".ecom-item-group-init") &&
              r
                .querySelector(".ecom-item-group-init")
                .classList.remove("ecom-item-group-init");
          }, 500),
        setTimeout(function () {
          g();
        }, 300),
        window.addEventListener("resize", function () {
          w(h);
        }),
        window.addEventListener("hashchange", g, !1));
    };
    (document.querySelectorAll(".ecom-ssu8aoawg4").forEach(function (t) {
      e.call({
        $el: t,
        id: "ecom-ssu8aoawg4",
        settings: { disable_auto_close: !1, disable_effect: !1, close_all: !1 },
        isLive: !0
      });
    }),
      document.querySelectorAll(".ecom-c5tga33je4").forEach(function (t) {
        e.call({
          $el: t,
          id: "ecom-c5tga33je4",
          settings: {
            disable_auto_close: !1,
            disable_auto_close__mobile: !1,
            disable_effect: !1,
            close_all: !0
          },
          isLive: !0
        });
      }));
  })(),
  (function () {
    const e = function () {
      "use strict";
      ((window.__ectimmers = window.__ectimmers || {}),
        (window.__ectimmers["ecom-n43ptvv89v"] =
          window.__ectimmers["ecom-n43ptvv89v"] || {}));
      let e = this.$el.querySelector(".ecom-product-single__review-wrapper");
      if (e && e.dataset.reviewPlatform && !this.isLive)
        switch (e.dataset.reviewPlatform) {
          case "product-reviews":
            if (window.SPR)
              try {
                ((window.SPR.$ = window.jQuery),
                  window.SPR.initDomEls(),
                  window.SPR.loadProducts());
              } catch (e) {
                console.info(e.message);
              }
            break;
          case "judgeme":
            window.jdgm &&
              "function" == typeof window.jdgm.initializeWidgets &&
              window.jdgm.initializeWidgets();
            break;
          case "product-reviews-addon":
            window.StampedFn && window.StampedFn.init();
            break;
          case "yotpo-social-reviews":
            break;
          case "lai-reviews":
            "undefined" != typeof SMARTIFYAPPS &&
              window.SMARTIFYAPPS.rv.installed &&
              window.SMARTIFYAPPS.rv.scmReviewsRate.actionCreateReviews();
        }
    };
    document.querySelectorAll(".ecom-n43ptvv89v").forEach(function (t) {
      e.call({ $el: t, id: "ecom-n43ptvv89v", settings: {}, isLive: !0 });
    });
  })(),
  (function () {
    const e = function () {
      "use strict";
      var e, t;
      ((window.__ectimmers = window.__ectimmers || {}),
        (window.__ectimmers["ecom-g30ti8u35bp"] =
          window.__ectimmers["ecom-g30ti8u35bp"] || {}));
      let o = this.$el;
      if (!o) return;
      let i = o.querySelector("afterpay-placement.ecom-afterpay-integrate"),
        n = this.$el.closest(".ecom-product-form--single");
      if (n) {
        let e = n.querySelector('[name="id"]');
        if (
          (e && e.dispatchEvent(new window.Event("ecomUpdate")),
          this.settings.show_total_price)
        ) {
          const e = n.querySelector(".ecom-product-single__quantity-input"),
            t = o.querySelector(".ecom-product-single__price--sale");
          if ((o.querySelector(".ecom-product-single__price--regular"), !t))
            return;
          (e &&
            e.addEventListener("change", function () {
              t.innerHTML = window.EComposer.formatMoney(
                parseInt(t.getAttribute("data-price")) * parseInt(this.value)
              );
            }),
            n.addEventListener("ecomVariantChange", function (o) {
              if (o.detail.variant) {
                const i = o.detail.variant,
                  n = e ? parseInt(e.value) : 1;
                (t.setAttribute("data-price", i.price),
                  n > 1 &&
                    (t.innerHTML = window.EComposer.formatMoney(
                      i.price * parseInt(n)
                    )));
              }
            }));
        }
      }
      if (this.settings.enable_afterpay) {
        let o = window.document.querySelector("#ecom-after-pay-script");
        if (((window.afterpay_min = this.settings.lower_limit || 1), o))
          ((o.dataset.analyticsEnabled = !0),
            (o.dataset.min = null != (e = this.settings.lower_limit) ? e : 1),
            (o.dataset.max =
              null != (t = this.settings.upper_limit) ? t : 1e3));
        else {
          let e = window.document.createElement("script");
          ((e.id = "ecom-after-pay-script"),
            (e.dataset.analyticsEnabled = !0),
            (e.dataset.min = this.settings.lower_limit || 1),
            (e.dataset.max = this.settings.upper_limit || 1e3),
            (e.src = "https://js.afterpay.com/afterpay-1.x.js"),
            window.document.head.appendChild(e));
        }
        i &&
          this.isLive &&
          window.jQuery &&
          window.Afterpay &&
          window.Afterpay.initProductPage &&
          window.Afterpay.initProductPage(window.jQuery);
      }
      let c = o.querySelector(".ecom-product-single__price--badges-sale");
      if (c && "true" == c.dataset.haveSale) {
        let e = c.dataset.sale,
          t = c.dataset.text;
        ((t = t.replace(/\{.*\}/g, e)),
          (c.innerHTML = t),
          (c.style.display = "block"));
      }
    };
    document.querySelectorAll(".ecom-g30ti8u35bp").forEach(function (t) {
      e.call({
        $el: t,
        id: "ecom-g30ti8u35bp",
        settings: {
          enable_afterpay: !1,
          lower_limit: "100",
          upper_limit: "600"
        },
        isLive: !0
      });
    });
  })(),
  (function () {
    const e = function () {
      "use strict";
      if (
        ((window.__ectimmers = window.__ectimmers || {}),
        (window.__ectimmers["ecom-0b4owah2xdup"] =
          window.__ectimmers["ecom-0b4owah2xdup"] || {}),
        !this.$el)
      )
        return !1;
      const e = this.$el,
        t = e.closest(".ecom-product-form--single");
      if (!t) return !1;
      if (t) {
        let o = t.querySelector('[name="id"]');
        if (
          (o && o.dispatchEvent(new window.Event("ecomUpdate")),
          this.settings.show_total_price)
        ) {
          const o = t.querySelector(".ecom-product-single__quantity-input"),
            i = e.querySelector(".ecom-product-single__price--sale");
          if (!i) return;
          (o &&
            o.addEventListener("change", function () {
              i.innerHTML = window.EComposer.formatMoney(
                parseInt(i.getAttribute("data-price")) * parseInt(this.value)
              );
            }),
            t.addEventListener("ecomVariantChange", function (e) {
              if (e.detail.variant) {
                const t = e.detail.variant,
                  n = o ? parseInt(o.value) : 1;
                (i.setAttribute("data-price", t.price),
                  n > 1 &&
                    (i.innerHTML = window.EComposer.formatMoney(
                      t.price * parseInt(n)
                    )));
              }
            }));
        }
      }
      const o = t.querySelector('select[name="id"]'),
        i = e.querySelector(".ecom-product-single__add-to-cart--submit"),
        n = e.closest("form");
      if (!n) return;
      function c() {
        let t = null;
        const o = n.dataset.product_id;
        let c = null;
        if (
          ((c = o
            ? n.querySelector("[id^=product-json-" + o + "]")
            : e.querySelector("[id^=addtocart-product-json]")),
          !c)
        )
          return;
        try {
          t = JSON.parse(c.innerHTML);
        } catch (e) {
          return;
        }
        let r = t.variants[0];
        if (r) {
          const e = i.querySelector(".ecom-add-to-cart-text");
          if (!e) return;
          0 == r.available
            ? (i.setAttribute("disabled", "disabled"),
              (e.innerText = i.dataset.textOutstock),
              i.classList.remove("ecom-product-single__pre-order"))
            : r.inventory_quantity <= 0 &&
              "continue" == r.inventory_policy &&
              r.inventory_management &&
              ((e.innerText = i.dataset.textPreOrder),
              i.classList.add("ecom-product-single__pre-order"));
        }
      }
      if (this.isLive) {
        let r = function (e) {
          const o = t.querySelectorAll(".ecom-required--checkbox");
          o.length > 0 &&
            o.forEach(function (e) {
              let t = e.querySelectorAll("input[type=checkbox]");
              if (0 == t.length) return;
              let o = !1;
              (t.forEach(function (e) {
                e.checked && (o = !0);
              }),
                o
                  ? t.forEach(function (e) {
                      e.required = !1;
                    })
                  : t.forEach(function (e) {
                      e.required = !0;
                    }));
            });
          const i = t.querySelectorAll(".ecom-product-single__property-file");
          let n,
            c = !1;
          (i.length &&
            i.forEach(function (e) {
              if (e.required && (!e.value || "" == e.value))
                return (
                  (e.parentNode.parentNode.querySelector(
                    ".ecom-product-single-form--text-error"
                  ).style.display = "block"),
                  (c = !0),
                  void (n = e)
                );
              c = !1;
            }),
            c &&
              (e.preventDefault(),
              e.stopPropagation(),
              n.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest"
              })));
        };
        if (
          ((!n.querySelector("select[name=id]") ||
            (n.querySelector("select[name=id]") &&
              o.classList.contains(
                "ecom-product-single__picker-default-variant"
              ))) &&
            c(),
          !o && i && i.dataset.variant_id)
        ) {
          const t = document.createElement("input");
          ((t.type = "hidden"),
            (t.value = i.dataset.variant_id),
            e.appendChild(t));
        }
        i.addEventListener("click", r);
      } else
        t &&
          (o &&
          !o.classList.contains("ecom-product-single__picker-default-variant")
            ? o.dispatchEvent(new window.Event("ecomUpdate"))
            : c());
      this.settings.animation &&
        (function (t) {
          if (!e) return;
          const o = e.querySelector(
            ".ecom-product-single__add-to-cart--submit"
          );
          if (!o) return;
          let i = 1e3 * parseInt(t.settings.animation_loop_time) || 6e3;
          window.__ectimmers["ecom-0b4owah2xdup"]["5u5eoevc3"] = setInterval(
            function () {
              (o.classList.add("animated"),
                setTimeout(function () {
                  o.classList.remove("animated");
                }, 1e3));
            },
            i
          );
        })(this);
    };
    document.querySelectorAll(".ecom-0b4owah2xdup").forEach(function (t) {
      e.call({
        $el: t,
        id: "ecom-0b4owah2xdup",
        settings: { animation: !1 },
        isLive: !0
      });
    });
  })(),
  (function () {
    const e = function () {
      "use strict";
      if (
        ((window.__ectimmers = window.__ectimmers || {}),
        (window.__ectimmers["ecom-dznbi01opw5"] =
          window.__ectimmers["ecom-dznbi01opw5"] || {}),
        !this.$el)
      )
        return !1;
      const e = this.$el;
      this.settings.animation &&
        (function (t) {
          if (!e) return;
          const o = e.querySelector(".ecom__element--button");
          if (!o) return;
          let i = 1e3 * parseInt(t.settings.animation_loop_time) || 6e3;
          window.__ectimmers["ecom-dznbi01opw5"]["852myr6ds"] = setInterval(
            function () {
              (o.classList.add("animated"),
                setTimeout(function () {
                  o.classList.remove("animated");
                }, 1e3));
            },
            i
          );
        })(this);
      var t = e.querySelector(".ecom__element--button");
      (this.isLive &&
        t &&
        t.dataset.ecTrackingId &&
        t.addEventListener(
          "click",
          function (e) {
            if (window.Shopify.analytics) {
              e.preventDefault();
              let o = document.createElement("div");
              (document.body.appendChild(o), o.click());
              let i =
                window.EComposer.PAGE ||
                window.EComposer.TEMPLATE ||
                window.EComposer.SECTION ||
                window.EComposer.BLOCK ||
                {};
              const n = U(
                { button_id: t.id, tracking_id: t.dataset.ecTrackingId },
                i
              );
              (Shopify.analytics.publish("ec_custom_events", n),
                t.cloneNode(!0).click());
            }
          },
          { once: !0 }
        ),
        this.isLive &&
          t &&
          t.dataset.eventTrackingFb &&
          t.addEventListener(
            "click",
            function (e) {
              window.fbq && window.fbq("track", "" + t.dataset.eventTrackingFb);
            },
            { once: !0 }
          ));
    };
    (document.querySelectorAll(".ecom-dznbi01opw5").forEach(function (t) {
      e.call({
        $el: t,
        id: "ecom-dznbi01opw5",
        settings: { animation: !1 },
        isLive: !0
      });
    }),
      document.querySelectorAll(".ecom-817a1jwv1x3").forEach(function (t) {
        e.call({
          $el: t,
          id: "ecom-817a1jwv1x3",
          settings: { animation: !1 },
          isLive: !0
        });
      }),
      document.querySelectorAll(".ecom-mwuiej2m3xo").forEach(function (t) {
        e.call({
          $el: t,
          id: "ecom-mwuiej2m3xo",
          settings: { animation: !1 },
          isLive: !0
        });
      }),
      document.querySelectorAll(".ecom-kcd424z5im").forEach(function (t) {
        e.call({
          $el: t,
          id: "ecom-kcd424z5im",
          settings: { animation: !1 },
          isLive: !0
        });
      }),
      document.querySelectorAll(".ecom-25hidtt5makj").forEach(function (t) {
        e.call({
          $el: t,
          id: "ecom-25hidtt5makj",
          settings: { animation: !1 },
          isLive: !0
        });
      }));
  })(),
  (function () {
    const e = function () {
      "use strict";
      var e;
      ((window.__ectimmers = window.__ectimmers || {}),
        (window.__ectimmers["ecom-wejre58bki8"] =
          window.__ectimmers["ecom-wejre58bki8"] || {}));
      const t = this.$el;
      if (!t) return;
      const o = null != (e = this.settings.thousandSeparator) && e,
        i = t.querySelectorAll(".element__counter--number");
      function n() {
        i.forEach(function (e) {
          if (
            !0 === e.counterAlreadyFired ||
            !(function (e) {
              if (!e) return !1;
              let t = window.scrollY || window.pageYOffset,
                o = e.getBoundingClientRect().top + t,
                i = t,
                n = t + window.innerHeight,
                c = o,
                r = o + e.clientHeight;
              return (r >= i && r <= n) || (c <= n && c >= i);
            })(e)
          )
            return !1;
          (e.updateCounter(),
            (e.counterAlreadyFired = !0),
            window.removeEventListener("scroll", n));
        });
      }
      (i.forEach(function (e) {
        ((e.counterAlreadyFired = !1),
          (e.counterDuration = +e.getAttribute("data-duration")),
          (e.counterInitVal = +e.getAttribute("data-from-value")),
          (e.counterLastVal = +e.getAttribute("data-to-value")),
          (e.counterStep = +e.getAttribute("data-step")),
          (e.updateCounter = function () {
            if (e.counterInitVal === e.counterLastVal) return !1;
            let t = e.counterLastVal - e.counterInitVal,
              i = e.counterInitVal,
              n = e.counterStep,
              c = Math.abs(Math.floor((e.counterDuration / t) * n)),
              r = (window.__ectimmers["ecom-wejre58bki8"]["4q5fcprag"] =
                setInterval(function () {
                  ((i += n),
                    i >= e.counterLastVal
                      ? (clearInterval(r),
                        (e.innerText = o
                          ? e.counterLastVal
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          : e.counterLastVal))
                      : (e.innerText = o
                          ? i.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          : i));
                }, c));
          }));
      }),
        window.addEventListener("scroll", n),
        n());
    };
    (document.querySelectorAll(".ecom-wejre58bki8").forEach(function (t) {
      e.call({
        $el: t,
        id: "ecom-wejre58bki8",
        settings: { thousandSeparator: !0 },
        isLive: !0
      });
    }),
      document.querySelectorAll(".ecom-fj1vjqzb1ib").forEach(function (t) {
        e.call({ $el: t, id: "ecom-fj1vjqzb1ib", settings: {}, isLive: !0 });
      }));
  })(),
  (function () {
    const e = function () {
      "use strict";
      if (
        ((window.__ectimmers = window.__ectimmers || {}),
        (window.__ectimmers["ecom-c4fj7rgsnji"] =
          window.__ectimmers["ecom-c4fj7rgsnji"] || {}),
        !this.$el)
      )
        return !1;
      const e = this.$el,
        t = this,
        o = this.settings.animation,
        i = new CustomEvent("animation", function () {});
      let n = e.querySelector(".ecom__heading");
      function c() {
        if ("typing" === o) {
          let o = function () {
              setTimeout(
                function () {
                  var e;
                  let t = null == (e = l.settings) ? void 0 : e.animation;
                  if (((i.innerText = n[s].slice(0, c)), r)) {
                    if (c > n[s].length)
                      return (
                        (r = !1),
                        void (
                          "typing" == t &&
                          setTimeout(function () {
                            o();
                          }, 2e3)
                        )
                      );
                    c++;
                  } else 0 === c ? ((r = !0), (s = (s + 1) % n.length)) : c--;
                  o();
                },
                r ? 120 : 60
              );
            },
            i = e.querySelector(".highlight-animation--typing");
          if (!i) return !1;
          let n = i.dataset.heading.split("|") || "",
            c = 0,
            r = !0,
            s = 0;
          const l = t;
          o();
        }
        if ("smooth" === o) {
          let t = function () {
              let e = 0,
                t = (window.__ectimmers["ecom-c4fj7rgsnji"].lj5vbwvwf =
                  setInterval(function () {
                    ("smooth" != o && clearInterval(t),
                      e++,
                      i.forEach((t, o) => {
                        (e == i.length && (e = 0),
                          o == e
                            ? t.classList.add("is-active")
                            : t.classList.remove("is-active"));
                      }));
                  }, 3e3));
            },
            i = e.querySelectorAll(".heading-animation--smooth-item");
          if (!i) return !1;
          t();
        }
      }
      (n.querySelector("a") && (n = n.querySelector("a")),
        n.addEventListener("animation", () => {
          c();
        }),
        n.addEventListener("blur", function (e) {
          e.target.dispatchEvent(i);
        }),
        c());
    };
    document.querySelectorAll(".ecom-c4fj7rgsnji").forEach(function (t) {
      e.call({
        $el: t,
        id: "ecom-c4fj7rgsnji",
        settings: { animation: "off" },
        isLive: !0
      });
    });
  })(),
  (function () {
    const e = function () {
      "use strict";
      if (
        ((window.__ectimmers = window.__ectimmers || {}),
        (window.__ectimmers["ecom-35catk6b8qr"] =
          window.__ectimmers["ecom-35catk6b8qr"] || {}),
        "lightbox" === this.settings.link &&
          "yes" === this.settings.lightbox &&
          window.EComModal &&
          this.$el)
      ) {
        var e = this.$el.querySelector("[ecom-modal]");
        new window.EComModal(e, {
          cssClass: ["ecom-container-lightbox-" + this.id]
        });
      }
      let t = this.$el;
      function o() {
        let e = t.querySelector(".ecom-element.ecom-base-image"),
          o = t.closest(".core__row--columns");
        e &&
          ((function (e) {
            const t = e.getBoundingClientRect();
            return (
              t.top >= 0 &&
              t.left >= 0 &&
              t.bottom - e.offsetHeight / 2 <=
                (window.innerHeight || document.documentElement.clientHeight) &&
              t.right <=
                (window.innerWidth || document.documentElement.clientWidth)
            );
          })(e)
            ? (e.classList.add("image-highlight"),
              o.setAttribute("style", "z-index: unset"))
            : (e.classList.remove("image-highlight"),
              o.setAttribute("style", "z-index: 1")));
      }
      t &&
        this.settings.highligh_on_viewport &&
        window.addEventListener("scroll", function () {
          o();
        });
    };
    (document.querySelectorAll(".ecom-35catk6b8qr").forEach(function (t) {
      e.call({
        $el: t,
        id: "ecom-35catk6b8qr",
        settings: { link: "none", lightbox: "no" },
        isLive: !0
      });
    }),
      document.querySelectorAll(".ecom-gn54nrojg7w").forEach(function (t) {
        e.call({
          $el: t,
          id: "ecom-gn54nrojg7w",
          settings: { link: "none", lightbox: "no", highligh_on_viewport: !1 },
          isLive: !0
        });
      }),
      document.querySelectorAll(".ecom-lilmhor1j4").forEach(function (t) {
        e.call({
          $el: t,
          id: "ecom-lilmhor1j4",
          settings: { link: "none", lightbox: "no" },
          isLive: !0
        });
      }),
      document.querySelectorAll(".ecom-ll8b2xqkby").forEach(function (t) {
        e.call({
          $el: t,
          id: "ecom-ll8b2xqkby",
          settings: { link: "none", lightbox: "no", highligh_on_viewport: !1 },
          isLive: !0
        });
      }),
      document.querySelectorAll(".ecom-mxop33qk6rr").forEach(function (t) {
        e.call({
          $el: t,
          id: "ecom-mxop33qk6rr",
          settings: { link: "none", lightbox: "no", highligh_on_viewport: !1 },
          isLive: !0
        });
      }),
      document.querySelectorAll(".ecom-4sqnv95yh8r").forEach(function (t) {
        e.call({
          $el: t,
          id: "ecom-4sqnv95yh8r",
          settings: { link: "none", lightbox: "no", highligh_on_viewport: !1 },
          isLive: !0
        });
      }),
      document.querySelectorAll(".ecom-7he532a1w3r").forEach(function (t) {
        e.call({
          $el: t,
          id: "ecom-7he532a1w3r",
          settings: { link: "none", lightbox: "no", highligh_on_viewport: !1 },
          isLive: !0
        });
      }),
      document.querySelectorAll(".ecom-xjom5vo1we").forEach(function (t) {
        e.call({
          $el: t,
          id: "ecom-xjom5vo1we",
          settings: { link: "none", lightbox: "no", highligh_on_viewport: !1 },
          isLive: !0
        });
      }),
      document.querySelectorAll(".ecom-a016mca3299").forEach(function (t) {
        e.call({
          $el: t,
          id: "ecom-a016mca3299",
          settings: { link: "none", lightbox: "no", highligh_on_viewport: !1 },
          isLive: !0
        });
      }),
      document.querySelectorAll(".ecom-9rgjsci8tu6").forEach(function (t) {
        e.call({
          $el: t,
          id: "ecom-9rgjsci8tu6",
          settings: { link: "none", lightbox: "no", highligh_on_viewport: !1 },
          isLive: !0
        });
      }),
      document.querySelectorAll(".ecom-rk3dvcmijb").forEach(function (t) {
        e.call({
          $el: t,
          id: "ecom-rk3dvcmijb",
          settings: { link: "none", lightbox: "no", highligh_on_viewport: !1 },
          isLive: !0
        });
      }),
      document.querySelectorAll(".ecom-nnpmns9wb").forEach(function (t) {
        e.call({
          $el: t,
          id: "ecom-nnpmns9wb",
          settings: { link: "none", lightbox: "no", highligh_on_viewport: !1 },
          isLive: !0
        });
      }));
  })(),
  (function () {
    const e = function () {
      "use strict";
      if (
        ((window.__ectimmers = window.__ectimmers || {}),
        (window.__ectimmers["ecom-vvqp34i0bc"] =
          window.__ectimmers["ecom-vvqp34i0bc"] || {}),
        !this.$el)
      )
        return;
      let e = this.$el;
      var t = this.id,
        o = e.querySelectorAll(".ecom-imgAccordion-item"),
        i = e.querySelectorAll(".ecom-imgAccordion-img-wrapper"),
        n = o.length,
        c = this.settings.expand_action,
        r = this.settings.place_click,
        s = !this.settings.disable_auto_video;
      function l(e) {
        var t = (4 * e.offsetWidth) / (n + 3);
        e.querySelectorAll(".ecom-imgAccordion-caption").forEach(function (e) {
          e.style.width = t + "px";
        });
      }
      (l(e),
        window.addEventListener("resize", function () {
          l(e);
        }),
        setTimeout(function () {
          e.querySelectorAll("video").forEach(function (e) {
            e.pause();
          });
        }, 100),
        "click" == c &&
          (i.forEach(function (e) {
            e.style.pointerEvents = "none";
          }),
          i[0] && i[0].removeAttribute("style"),
          e.querySelectorAll("video").forEach(function (e) {
            e.pause();
          })),
        document.addEventListener("click", function (t) {
          var o = t.target.classList;
          !o.contains("ecom-imgAccordion-item-expand") &&
            !o.contains("ecom-imgAccordion-prev") &&
            !o.contains("ecom-imgAccordion-next") &&
            ("button" != r || !o.contains("ecom-imgAccordion-video")) &&
            e.querySelectorAll("video").forEach(function (e) {
              e.pause();
            });
        }),
        o.forEach(function (t, o) {
          var n = t.querySelector("video");
          ("hover" == c &&
            t.addEventListener("mouseenter", function () {
              window.innerWidth > 1024 &&
                (i.forEach(function (e) {
                  e.style.pointerEvents = "none";
                }),
                t
                  .querySelector(".ecom-imgAccordion-img-wrapper")
                  .removeAttribute("style"),
                e
                  .querySelector(".ecom-imgAccordion-item-expand")
                  .classList.remove("ecom-imgAccordion-item-expand"),
                t.classList.add("ecom-imgAccordion-item-expand"),
                e.querySelectorAll("video").forEach(function (e) {
                  e.pause();
                }),
                n && s && n.play());
            }),
            t.addEventListener("click", function () {
              (i.forEach(function (e) {
                e.style.pointerEvents = "none";
              }),
                t
                  .querySelector(".ecom-imgAccordion-img-wrapper")
                  .removeAttribute("style"),
                e
                  .querySelector(".ecom-imgAccordion-item-expand")
                  .classList.remove("ecom-imgAccordion-item-expand"),
                t.classList.add("ecom-imgAccordion-item-expand"),
                e.querySelectorAll("video").forEach(function (e) {
                  e.pause();
                }),
                n && s && n.play());
            }),
            e.addEventListener("mouseenter", function () {
              t.classList.contains("ecom-imgAccordion-item-expand") &&
                n &&
                s &&
                n.play();
            }),
            e.addEventListener("mouseleave", function () {
              n && n.pause();
            }));
        }));
      var a = e.querySelectorAll("[ecom-modal]");
      a.length &&
        new window.EComModal(a, {
          cssClass: ["ecom-container-lightbox-" + t],
          onOpen: function () {
            document
              .querySelectorAll(".ecom-container-lightbox-" + t)
              .forEach(function (e) {
                const t = e.querySelector("video");
                null != t && s && t.play();
              });
          },
          onClose: function () {
            document
              .querySelectorAll(".ecom-container-lightbox-" + t)
              .forEach(function (e) {
                const t = e.querySelector("video");
                null != t && t.pause();
              });
          }
        });
      const d = e.querySelector(".ecom-swiper-container");
      var u,
        m = {
          slidesPerView: 1.4,
          spaceBetween: this.settings.item_spacing__mobile
            ? this.settings.item_spacing__mobile
            : 0,
          centeredSlides: !0,
          loop: !0,
          navigation: {
            nextEl: `.${this.id} .ecom-imgAccordion-next`,
            prevEl: `.${this.id} .ecom-imgAccordion-prev`
          }
        };
      function p() {
        (u = new window.EComSwiper(d, m)).on("slideChange", function () {
          e.querySelectorAll("video").forEach(function (e) {
            e.pause();
          });
          const t = u.slides[u.activeIndex];
          (t
            .querySelector(".ecom-imgAccordion-img-wrapper")
            .removeAttribute("style"),
            e
              .querySelector(".ecom-imgAccordion-item-expand")
              .classList.remove("ecom-imgAccordion-item-expand"),
            t.classList.add("ecom-imgAccordion-item-expand"));
          var o = t.querySelector("video");
          o && s && o.play();
        });
      }
      (this.settings.fullwidth_mobile &&
        ((m.slidesPerView = 1), (m.centeredSlides = !1)),
        window.innerWidth < 768 && p(),
        window.addEventListener("resize", function () {
          window.innerWidth < 768
            ? (!u || u.destroyed) &&
              (p(), i[u.activeIndex].removeAttribute("style"))
            : u && u.destroy(!0, !0);
        }));
    };
    document.querySelectorAll(".ecom-vvqp34i0bc").forEach(function (t) {
      e.call({
        $el: t,
        id: "ecom-vvqp34i0bc",
        settings: {
          expand_action: "hover",
          place_click: "item",
          disable_auto_video: !1,
          item_spacing__mobile: "12px",
          fullwidth_mobile: !1
        },
        isLive: !0
      });
    });
  })(),
  (function () {
    const e = function () {
      "use strict";
      ((window.__ectimmers = window.__ectimmers || {}),
        (window.__ectimmers["ecom-148h9csea8m"] =
          window.__ectimmers["ecom-148h9csea8m"] || {}));
      var e = this.$el;
      if (e && this.isLive) {
        var t = e.querySelectorAll(
          ".element-social-link:not(.element-social-link__custom)"
        );
        t.length &&
          t.forEach(function (e) {
            var t = (e.getAttribute("href") || "#").replace(
              "{current-link}",
              location.href
            );
            e.setAttribute("href", t);
          });
      }
    };
    document.querySelectorAll(".ecom-148h9csea8m").forEach(function (t) {
      e.call({ $el: t, id: "ecom-148h9csea8m", settings: {}, isLive: !0 });
    });
  })(),
  (function () {
    const e = function () {
      "use strict";
      if (
        ((window.__ectimmers = window.__ectimmers || {}),
        (window.__ectimmers["ecom-hi2v4l8so4h"] =
          window.__ectimmers["ecom-hi2v4l8so4h"] || {}),
        !this.$el)
      )
        return;
      const e = this.$el,
        t = this,
        o = this.settings.layout;
      let i = e.closest(".core__row--columns");
      const n = e.querySelector(".ecom-shopify__menu-list--mobile"),
        c = e.querySelector(".ecom-menu__icon-humber"),
        r = e.querySelector(".ecom-menu-collapse-close--mobile");
      let s = e.closest("div.ecom-core.core__block") || "",
        l = e.closest("div.ecom-column.ecom-core") || "",
        a = e.querySelectorAll(".ecom-shopify__menu-item--link");
      for (
        s && (s.style.overflow = "visible"),
          a &&
            n &&
            a.forEach(function (e) {
              e.addEventListener("click", function () {
                m();
              });
            }),
          c &&
            (c.addEventListener("click", function () {
              !n ||
                ((n.parentNode.style.display = "block"),
                n.classList.add("ecom-show"),
                s && (s.style.zIndex = "100"),
                l && (l.style.zIndex = "100"),
                document
                  .querySelector("body")
                  .classList.add("ecom-menu-opened"),
                setTimeout(function () {
                  (document.addEventListener("click", d),
                    document.addEventListener("keydown", u));
                }, 500));
            }),
            r.addEventListener("click", m));
        i;
      )
        ((i.style.zIndex = "100"),
          (i = i.parentElement.closest(".core__row--columns")));
      function d(e) {
        let t = e.target;
        do {
          if (t == n) return;
          t = t.parentNode;
        } while (t);
        t != n &&
          (m(),
          document.removeEventListener("click", d),
          document.removeEventListener("keydown", u));
      }
      function u(e) {
        (e.isComposing || 27 === e.keyCode) &&
          (m(),
          document.removeEventListener("keydown", u),
          document.removeEventListener("click", d));
      }
      function m() {
        ((n.parentNode.style.display = "none"),
          n.classList.remove("ecom-show"),
          s && (s.style.zIndex = "1"),
          l && (l.style.zIndex = "1"),
          document.querySelector("body").classList.remove("ecom-menu-opened"),
          document.removeEventListener("keydown", u),
          document.removeEventListener("click", d));
      }
      let p = e.querySelector(
          '.ecom-shopify__menu-list[data-menu-layout="horizontal"]'
        ),
        h = null;
      (p &&
        (h = p.querySelectorAll(
          ".ecom-shopify__menu-item--has-children>.ecom-menu_item>.ecom-element--menu_title"
        )),
        h &&
          h.forEach(function (e) {
            e.addEventListener("click", function (e) {
              e.preventDefault();
            });
          }),
        (function () {
          var i = e.querySelectorAll(
              ".ecom-shopify__menu-list .ecom-shopify__menu-item--has-children > .ecom-menu_item, .ecom-shopify__menu-list .ecom-shopify__menu-child-link-item--has-children > .ecom-menu_item"
            ),
            n = e.querySelectorAll(
              ".ecom-shopify__menu-list--mobile .ecom-shopify__menu-item--has-children > .ecom-menu_item, .ecom-shopify__menu-list--mobile .ecom-shopify__menu-child-link-item--has-children > .ecom-menu_item"
            );
          if (i) {
            var c,
              r = "false",
              s = e.querySelector(".ecom-shopify__menu-wrapper");
            if (s && s.dataset.showAll) r = s.dataset.showAll;
            for (c = 0; c < i.length; c++) {
              let e = function (e) {
                let t = e.nextElementSibling,
                  o = null;
                if (e.classList.contains("ecom-item-active")) {
                  if ((e.classList.remove("ecom-item-active"), t)) {
                    t.style.maxHeight = null;
                    var i = t.querySelectorAll(".ecom-menu_item");
                    (i &&
                      i.forEach((e) => {
                        var t = e.nextElementSibling;
                        (t && (t.style.maxHeight = null),
                          e.classList.remove("ecom-item-active"));
                      }),
                      (o = e.closest(".ecom-shopify__menu-sub-menu")),
                      o &&
                        (o.style.maxHeight =
                          parseInt(o.style.maxHeight) - t.scrollHeight + "px"));
                  }
                } else
                  (e.classList.add("ecom-item-active"),
                    t &&
                      ((o = e.closest(".ecom-shopify__menu-sub-menu")),
                      o &&
                        (o.style.maxHeight =
                          parseInt(o.style.maxHeight) + t.scrollHeight + "px"),
                      (t.style.maxHeight = t.scrollHeight + "px")));
              };
              ("horizontal" !== o || t.isLive
                ? "horizontal" === o && t.isLive
                  ? i[c].addEventListener("click", function (e) {
                      e.stopPropagation();
                    })
                  : ("vertical" === o || !t.isLive) &&
                    (r && "true" == r && e(i[c]),
                    i[c].addEventListener("click", function (t) {
                      (t.preventDefault(), e(this));
                    }))
                : i[c].addEventListener("click", function (e) {
                    e.preventDefault();
                  }),
                n[c] &&
                  n[c].addEventListener("click", function (t) {
                    (t.preventDefault(), e(this));
                  }));
            }
          }
        })());
    };
    (document.querySelectorAll(".ecom-hi2v4l8so4h").forEach(function (t) {
      e.call({
        $el: t,
        id: "ecom-hi2v4l8so4h",
        settings: { layout: "vertical" },
        isLive: !0
      });
    }),
      document.querySelectorAll(".ecom-wtornsb3u1").forEach(function (t) {
        e.call({
          $el: t,
          id: "ecom-wtornsb3u1",
          settings: { layout: "vertical" },
          isLive: !0
        });
      }));
  })(),
  (function () {
    const e = function () {
      "use strict";
      if (
        ((window.__ectimmers = window.__ectimmers || {}),
        (window.__ectimmers["ecom-v6uh86e42q9"] =
          window.__ectimmers["ecom-v6uh86e42q9"] || {}),
        !this.$el)
      )
        return;
      const e = this.$el,
        t = this.isLive,
        o = e.querySelectorAll(
          ".ecom__element.element__image-hotspot .element__image-hotspot--text"
        );
      this.isLive ||
        e
          .querySelectorAll(".element__image-hotspot--content-btn")
          .forEach((e) => {
            e.addEventListener("click", function (e) {
              (e.preventDefault(), e.stopPropagation());
              let t = this.getAttribute("href");
              t &&
                t.indexOf("/product") >= 0 &&
                (e.preventDefault(),
                window.open(window.EComposer.routes.domain + t));
            });
          });
      const i = async function (e) {
          e.querySelector(
            ".element__image-hotspot--content-image"
          ).style.opacity = 0;
          const t = e.querySelector(".ecom-hotspots-container-tooltip");
          if (
            (t && t.classList.add("ecom-loading-image"),
            !window.EComposer || !window.EComposer.getProduct)
          )
            return (console.log("EComposer theme helper not enabled"), !1);
          const o = e.getAttribute("data-handle"),
            i = e.getAttribute("data-limit");
          var n;
          e.dataset.product
            ? (n = JSON.parse(e.dataset.product)).handle !== o &&
              (n = await window.EComposer.getProduct(o))
            : (n = await window.EComposer.getProduct(o));
          const c = e.querySelector(".element__image-hotspot--content-image"),
            r = e.querySelector(".element__image-hotspot--content-title"),
            s = e.querySelector(".element__image-hotspot--content-text"),
            l = e.querySelectorAll(".element__image-hotspot--content-btn");
          if (n && n.id) {
            const t = e.querySelector(
              ".element__image-hotspot--content-prices"
            );
            if (
              (c && (c.src = n.featured_image),
              r && (r.innerText = n.title),
              s &&
                (s.innerText =
                  (function (e, t, o) {
                    if (!e || !t) return "";
                    let i = e.split(" ");
                    return i.length < t
                      ? e
                      : i.slice(0, t).join(" ") + (o || "");
                  })(
                    (function (e) {
                      if (e && e.length > 0) {
                        const t = document.createElement("div");
                        return (
                          (t.innerHTML = e),
                          t.textContent || t.innerText || ""
                        );
                      }
                      return "";
                    })(n.description),
                    parseInt(null != i ? i : 20),
                    "..."
                  ) || ""),
              l.forEach(function (e) {
                e.href = n.url;
              }),
              t)
            ) {
              let e = `<span class="element__image-hotspot--content-price">${window.EComposer.formatMoney(n.price)}</span>`;
              (n.price < n.compare_at_price &&
                (e += `<span class="element__image-hotspot--content-price--regular">${window.EComposer.formatMoney(n.compare_at_price)}</span>`),
                (t.innerHTML = e));
            }
            e.dataset.product = JSON.stringify(n);
          }
          (t && t.classList.remove("ecom-loading-image"),
            (e.querySelector(
              ".element__image-hotspot--content-image"
            ).style.opacity = 1));
        },
        n =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      function c(e) {
        let t = e.closest(".ecom-column.ecom-core"),
          o = e.closest(".ecom-row.ecom-core");
        (t && (t.style.zIndex = 101), o && (o.style.zIndex = 101));
      }
      function r(e) {
        let t = e.closest(".ecom-column.ecom-core"),
          o = e.closest(".ecom-row.ecom-core");
        (t && (t.style.zIndex = ""), o && (o.style.zIndex = ""));
      }
      o.forEach((o, s) => {
        const l = o.querySelector(".element__image-hotspot--btn"),
          a = o.closest(".ecom-block.ecom-core"),
          d = o.closest(".core__column--wrapper"),
          u = o.closest(".ecom-row.ecom-core"),
          m = o.querySelector(".element__image-hotspot--content");
        if ("link" === o.getAttribute("data-source")) {
          let e = o.getAttribute("data-redirect-link")
            ? JSON.parse(o.getAttribute("data-redirect-link"))
            : null;
          l.addEventListener("click", () => {
            this.isLive &&
              (null != e && e.href
                ? e.target
                  ? window.open(e.href, "_blank")
                  : (window.location.href = e.href)
                : window.location.reload());
          });
        } else {
          let e,
            s = function () {
              l.addEventListener("click", () => {
                if (m.classList.contains("ecom-hotspot-actived"))
                  (r(m),
                    m.classList.remove("ecom-hotspot-actived"),
                    a && (a.style.zIndex = "unset"),
                    d && (d.style.zIndex = "unset"),
                    u && (u.style.zIndex = "unset"));
                else {
                  if (
                    (c(m),
                    m.classList.add(
                      "ecom-hotspot-actived",
                      "ecom_current_click"
                    ),
                    n < 768)
                  ) {
                    var s = window.pageYOffset;
                    window.document.addEventListener("scroll", function () {
                      var e = window.pageYOffset;
                      (s - e > 100 || e - s > 100) &&
                        (m.classList.remove("ecom-hotspot-actived"),
                        document.removeEventListener("click", p),
                        r(m));
                    });
                  }
                  ("product" === o.getAttribute("data-source") &&
                    t &&
                    (clearTimeout(e), (e = setTimeout(() => i(o), 500))),
                    setTimeout(() => {
                      (document.addEventListener("click", p),
                        m.classList.remove("ecom_current_click"));
                    }, 300),
                    a && (a.style.zIndex = "99"),
                    d && (d.style.zIndex = "99"),
                    u && (u.style.zIndex = "99"));
                }
              });
            };
          l &&
            m &&
            ("hover" === this.settings.trigger
              ? window.innerWidth <= 767
                ? s()
                : (o.addEventListener("mouseover", () => {
                    if (
                      (c(m), m.classList.add("ecom-hotspot-actived"), n < 768)
                    ) {
                      var e = window.pageYOffset;
                      window.document.addEventListener("scroll", function () {
                        var t = window.pageYOffset;
                        (e - t > 100 || t - e > 100) &&
                          (m.classList.remove("ecom-hotspot-actived"),
                          document.removeEventListener("click", p),
                          r(m));
                      });
                    }
                    ("product" === o.getAttribute("data-source") && t && i(o),
                      a && (a.style.zIndex = "99"),
                      d && (d.style.zIndex = "99"),
                      u && (u.style.zIndex = "99"));
                  }),
                  o.addEventListener("mouseleave", function () {
                    (r(m),
                      m.classList.remove("ecom-hotspot-actived"),
                      a && (a.style.zIndex = "unset"),
                      d && (d.style.zIndex = "unset"),
                      u && (u.style.zIndex = "unset"));
                  }))
              : s());
        }
        function p(t) {
          (void 0 === t ||
            !t.target.closest(".ecom-hotspots-container-tooltip")) &&
            (e.querySelector(
              ".element__image-hotspot--content.ecom-hotspot-actived:not(.ecom_current_click)"
            ) &&
              e
                .querySelector(
                  ".element__image-hotspot--content.ecom-hotspot-actived:not(.ecom_current_click)"
                )
                .classList.remove("ecom-hotspot-actived"),
            r(m),
            document.removeEventListener("click", p),
            a && (a.style.zIndex = "unset"),
            d && (d.style.zIndex = "unset"),
            u && (u.style.zIndex = "unset"));
        }
      });
    };
    document.querySelectorAll(".ecom-v6uh86e42q9").forEach(function (t) {
      e.call({
        $el: t,
        id: "ecom-v6uh86e42q9",
        settings: { trigger: "hover" },
        isLive: !0
      });
    });
  })(),
  (function () {
    const e = function () {
      "use strict";
      var e, t, o, i;
      if (
        ((window.__ectimmers = window.__ectimmers || {}),
        (window.__ectimmers["ecom-0wewrfjeno8i"] =
          window.__ectimmers["ecom-0wewrfjeno8i"] || {}),
        !this.$el)
      )
        return !1;
      const n = this,
        c = this.$el,
        r = this.isLive,
        s =
          (this.settings.position_zoom && this.settings.position_zoom,
          {
            width: this.settings.zoom_width,
            height: this.settings.zoom_height
          }),
        l = c.closest(".ecom-product-form--single");
      (window.innerWidth,
        window.innerWidth,
        c.closest(".ecom-row"),
        window.matchMedia("only screen and (max-width: 768px)"));
      const a =
          !!this.settings.show_thumbnails && this.settings.show_thumbnails,
        d = this.settings.layout ? this.settings.layout : "slider",
        u = !!this.settings.enable_zoom && this.settings.enable_zoom;
      var m,
        p,
        h = this.settings.thumbnail_position,
        f = this.settings.thumbnail_position__tablet,
        w = this.settings.thumbnail_position__mobile,
        _ = !!this.settings.show_pagination,
        g = null != (e = this.settings.enable_gallery) && e,
        v = null != (t = this.settings.gallery_name) && t,
        y = null != (o = this.settings.centeredSlides) && o,
        b = null != (i = this.settings.slide_loop) && i,
        S = this.settings.disable_auto_height;
      function q() {
        if ("slider" === d)
          try {
            if (a) {
              const e = n.$el.querySelector(
                ".ecom-product-single__media--thumbs"
              );
              let t = JSON.parse(e.dataset.breakpoints);
              (Object.keys(t).forEach((e) => {
                t[e].__screen_name;
                t[e].direction = ["row", "row-reverse"].includes(
                  t[e].thumbnail_position
                )
                  ? "vertical"
                  : "horizontal";
              }),
                e.hasChildNodes() &&
                  (m = new window.EComSwiper(e, {
                    freeMode: !1,
                    centeredSlides: !1,
                    loop: !1,
                    centeredSlidesBounds: !0,
                    slideToClickedSlide: !0,
                    autoHeight: !!(
                      (["row", "row-reverse"].includes(h) &&
                        window.screen.width > 1024) ||
                      (["row", "row-reverse"].includes(f) &&
                        (window.screen.width >= 768 ||
                          window.screen.width <= 1024)) ||
                      (["row", "row-reverse"].includes(w) &&
                        window.screen.width < 768)
                    ),
                    navigation: {
                      nextEl: n.$el.querySelector(
                        ".ecom-product-single__media--thumbs .ecom-swiper-button-next"
                      ),
                      prevEl: n.$el.querySelector(
                        ".ecom-product-single__media--thumbs .ecom-swiper-button-prev"
                      )
                    },
                    allowTouchMove: r,
                    watchSlidesProgress: !0,
                    grabCursor: !0,
                    centerInsufficientSlides: !1,
                    breakpoints: t,
                    direction: ["row", "row-reverse"].includes(h)
                      ? "vertical"
                      : "horizontal",
                    on: {
                      slideChangeTransitionEnd: function () {},
                      breakpoint: function () {
                        setTimeout(
                          () =>
                            window.dispatchEvent(new window.Event("resize")),
                          500
                        );
                      },
                      init: function () {
                        setTimeout(() => {
                          this.el &&
                            this.el.classList.remove(
                              "ecom-product-single__init-thumb-hidden"
                            );
                        }, 50);
                      }
                    }
                  })));
              let o = null;
              e.querySelectorAll("img").forEach(function (e) {
                e.addEventListener("load", function () {
                  (clearTimeout(o),
                    (o = setTimeout(
                      () => window.dispatchEvent(new window.Event("resize")),
                      500
                    )));
                });
              });
            }
            const t = c.querySelector(".ecom-product-single__media--featured");
            var e = t.dataset.breakpoints;
            ((e = e
              ? JSON.parse(e)
              : { 0: { slidesPerView: 1, spaceBetween: 20 } }),
              (p = new window.EComSwiper(t, {
                autoHeight: null == S || S,
                lazy: !0,
                allowTouchMove: r,
                pagination: !!_ && {
                  el: t.querySelector(".ecom-swiper-pagination"),
                  dynamicBullets: !0,
                  clickable: !0
                },
                navigation: {
                  nextEl: c.querySelector(
                    ".ecom-product-single__media--featured .ecom-swiper-button-next"
                  ),
                  prevEl: c.querySelector(
                    ".ecom-product-single__media--featured .ecom-swiper-button-prev"
                  )
                },
                thumbs: a && m ? { swiper: m } : void 0,
                noSwiping: !0,
                longSwipes: !0,
                loop: b,
                centeredSlides: y,
                touchStartPreventDefault: !0,
                noSwipingSelector: "model-viewer",
                noSwipingClass: "ecom-product-single__media--model",
                grabCursor: !0,
                preloadImages: !0,
                breakpoints: e,
                on: {
                  breakpoint: function () {
                    setTimeout(
                      () => window.dispatchEvent(new window.Event("resize")),
                      500
                    );
                  },
                  slideChange: function (e) {
                    var t, o;
                    if (g) return;
                    e.activeIndex !== e.lastIndex &&
                      (e.lastIndex = e.activeIndex + "");
                    const i = l && l.querySelector('[name="id"]');
                    if (i) {
                      let e = null;
                      if (!p || !p.slides[p.activeIndex]) return;
                      if (
                        ((e =
                          null ==
                          (o =
                            null == (t = p.slides[p.activeIndex])
                              ? void 0
                              : t.dataset)
                            ? void 0
                            : o.variant_id),
                        e)
                      ) {
                        e += "";
                        const t = i.value;
                        (!t || !e.includes(t.toString())) &&
                          ((i.value = e.split(",")[0]),
                          i.dispatchEvent(new Event("swatch")));
                      }
                    }
                    e.slides[e.activeIndex] && u && L(e.slides[e.activeIndex]);
                  },
                  slideChangeTransitionEnd: function (e) {
                    var t, o;
                    (window.dispatchEvent(new window.Event("resize")),
                      e.slides.forEach((e) => {
                        if (e.classList.contains("ecom-swiper-slide-active")) {
                          let t = e.querySelector("video");
                          t && t.hasAttribute("autoplay") && t.play();
                        } else {
                          let t = e.querySelector("iframe,video");
                          t &&
                            ("IFRAME" === t.nodeName
                              ? (t.src = t.src)
                              : t.pause());
                        }
                      }),
                      r &&
                        (a && m && m.update(),
                        (e.allowTouchMove = !(
                          null !=
                            (o =
                              null == (t = e.slides[p.activeIndex])
                                ? void 0
                                : t.classList) &&
                          o.contains("ecom-swiper-no-swiping")
                        ))));
                  },
                  init: function (e) {
                    e.slides[e.activeIndex] && u && L(e.slides[e.activeIndex]);
                  }
                }
              })));
            let o = null;
            (t.querySelectorAll("img").forEach(function (e) {
              e.addEventListener("load", function () {
                (clearTimeout(o),
                  (o = setTimeout(
                    () => window.dispatchEvent(new window.Event("resize")),
                    500
                  )));
              });
            }),
              r ||
                setTimeout(() => {
                  t.classList.remove("ecom-before-init");
                }, 200));
          } catch (e) {
            console.info(e.message);
          }
      }
      async function E(e) {
        const t = await window.fetch(e, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        });
        if (t.ok) {
          const e = await t.json();
          if (e) return e.product;
        }
        return !1;
      }
      if (
        (q(),
        g &&
          (async function () {
            const e = c.querySelectorAll(
                ".ecom-product-single__media--image img"
              ),
              t =
                c &&
                c.querySelector(
                  ".ecom-product-single__media--featured .ecom-product-single__media--images-layout__slider"
                ),
              o = t && t.querySelectorAll(".ecom-product-single__media--image"),
              i = c && c.querySelector(".ecom-product-single__media--featured"),
              s = c && c.querySelector(".ecom-product-single__media--thumbs"),
              a =
                c &&
                c.querySelector(
                  ".ecom-product-single__media--slider .ecom-product-single__media--thumbs .ecom-swiper-wrapper"
                ),
              d =
                s &&
                s.querySelectorAll(".ecom-product-single__media--thumbnail"),
              p =
                c &&
                c.querySelector(
                  ".ecom-product-single__media--grid .ecom-product-single__media--images-layout__grid"
                ),
              h = p && p.querySelectorAll(".ecom-product-single__media--image");
            let f = !0;
            if (
              (e &&
                e.forEach(function (e, t) {
                  e && e.alt && e.alt.includes("ecomposer-") && (f = !1);
                }),
              f)
            )
              return;
            let w = null,
              _ =
                l && l.querySelector(".ecom-product-single-select-id[name=id]");
            if (!_) return;
            const y = l && l.querySelector("#" + _.dataset.jsonProduct);
            if (!y) return;
            try {
              w = JSON.parse(y.innerHTML);
            } catch (e) {
              return;
            }
            let b = null;
            if (r && window.Shopify && "/" != window.Shopify.routes.root) {
              let e =
                window.location.origin + "/products/" + w.handle + ".json";
              ((b = await E(e)),
                b ||
                  ((e =
                    window.location.origin +
                    window.Shopify.routes.root +
                    "products/" +
                    w.handle +
                    ".json"),
                  (b = await E(e))),
                (w.options_with_values = b.options),
                (w.variants = b.variants));
            }
            let S = { detail: { variant: null } };
            S.detail.variant = w.variants.find(function (e) {
              if (e.id == _.value) return e;
            });
            let A = c.querySelector("#ecom-single-product-default-variant"),
              x = A && A.innerText,
              k = A.dataset.dontSetAlt;
            function C(e) {
              if (
                e.detail.variant &&
                (e.target &&
                  e.target.querySelector(
                    ".ecom-product-single__variant-picker-container"
                  ),
                g && v)
              ) {
                let f = function (e) {
                    let t = e.options_with_values,
                      o = [];
                    v.includes(",")
                      ? v.split(",").forEach((e, i) => {
                          t &&
                            t.forEach(function (t) {
                              t.name.trim().toLowerCase() ===
                                e.trim().toLowerCase() &&
                                (o = o.concat({
                                  key: t.name.trim(),
                                  value: t.values
                                }));
                            });
                        })
                      : t &&
                        t.forEach(function (e) {
                          e.name.trim().toLowerCase() !== v.toLowerCase() ||
                            (o = o.concat({
                              key: e.name.trim(),
                              value: e.values
                            }));
                        });
                    let i = [];
                    return (
                      o &&
                        o.forEach(function (e, t) {
                          e.value.forEach((t) => {
                            (x.option1 == t &&
                              i.push(
                                `ecomposer-${e.key.toLowerCase()}-${x.option1.replaceAll(" ", "-").toLowerCase()}`
                              ),
                              x.option2 == t &&
                                i.push(
                                  `ecomposer-${e.key.toLowerCase()}-${x.option2.replaceAll(" ", "-").toLowerCase()}`
                                ),
                              x.option3 == t &&
                                i.push(
                                  `ecomposer-${e.key.toLowerCase()}-${x.option3.replaceAll(" ", "-").toLowerCase()}`
                                ));
                          });
                        }),
                      i
                    );
                  },
                  _ = function (e, t, o, i, c) {
                    if (i && t && w && o.length) {
                      ((t.innerHTML = ""),
                        o.forEach(function (e) {
                          let o =
                            e.querySelector("img") &&
                            e.querySelector("img").alt;
                          if (o)
                            if (o.includes(",")) {
                              ((o = o.split(",")),
                                (o = o.map(function (e) {
                                  return e.trim().toLowerCase();
                                })));
                              let i = f(w).filter((e) => -1 !== o.indexOf(e));
                              (y(i, o) || (b(i, o) && i.length === S(o))) &&
                                (e
                                  .querySelector("img")
                                  .removeAttribute("loading"),
                                t.appendChild(e));
                            } else
                              f(w).includes(o.toLowerCase()) &&
                                (e
                                  .querySelector("img")
                                  .removeAttribute("loading"),
                                t.appendChild(e));
                        }),
                        (t.style = c),
                        e.prepend(t));
                      const i = n.$el.querySelector(
                        ".ecom-product-single__media--thumbs"
                      );
                      (m &&
                        (m.destroy(),
                        i.classList.add(
                          "ecom-product-single__init-thumb-hidden"
                        )),
                        q());
                    }
                  },
                  y = function (e, t) {
                    return e.sort().join() === t.sort().join();
                  },
                  b = function (e, t) {
                    return e.every((e) => t.includes(e));
                  },
                  S = function (e) {
                    const t = new Set();
                    let o = 0;
                    for (const i of e) {
                      const e = i.indexOf("-", i.indexOf("-") + 1),
                        n = i.substring(10, e);
                      t.has(n) || (t.add(n), o++);
                    }
                    return o;
                  },
                  E = function (e) {
                    const t =
                      l &&
                      l.querySelector(
                        ".ecom-product-single__media--grid_default"
                      );
                    if (!t || !e || !w) return;
                    let o =
                      t &&
                      t.querySelectorAll(".ecom-product-single__media--image");
                    o.length &&
                      (v && g
                        ? o.forEach(function (e) {
                            e.style.display = "none";
                            let t = e.querySelector("img").alt;
                            if (t.includes(",")) {
                              ((t = t.split(",")),
                                (t = t.map(function (e) {
                                  return e.trim().toLowerCase();
                                })));
                              let o = f(w).filter((e) => -1 !== t.indexOf(e));
                              (y(o, t) || (b(o, t) && o.length === S(t))) &&
                                (e.style.display = "block");
                            } else
                              f(w).includes(t.toLowerCase()) &&
                                (e.style.display = "block");
                          })
                        : o.forEach(function (e) {
                            e.style.display = "flex";
                          }));
                  },
                  A = function (e) {
                    if (e && p && w) {
                      p.innerHTML = "";
                      let e = [];
                      (h.forEach(function (t, o) {
                        let i = t.querySelector("img").alt;
                        if (i.includes(",")) {
                          ((i = i.split(",")),
                            (i = i.map(function (e) {
                              return e.trim().toLowerCase();
                            })));
                          let o = f(w).filter((e) => -1 !== i.indexOf(e));
                          (y(o, i) || (b(o, i) && o.length === S(i))) &&
                            e.push(t);
                        } else f(w).includes(i.toLowerCase()) && e.push(t);
                      }),
                        e.forEach(function (t, o) {
                          (0 == o ||
                          (o >= 5 && o % 5 == 0) ||
                          (o % 5 != 0 &&
                            (o + 1) % 2 == 0 &&
                            o == e.length - 1) ||
                          (1 == o && 2 == e.length)
                            ? (t.style.paddingTop = t.dataset.fullWidth + "%")
                            : (t.style.paddingTop = t.dataset.halfWidth + "%"),
                            p.appendChild(t));
                        }));
                    }
                  },
                  x = e.detail.variant;
                r &&
                  window.Shopify &&
                  "/" != window.Shopify.routes.root &&
                  (x = w.variants.find(function (e) {
                    if (
                      e.id ==
                      l.querySelector(".ecom-product-single-select-id[name=id]")
                        .value
                    )
                      return e;
                  }));
                const k = a && a.style,
                  C = t && t.style;
                if ((_(i, t, o, x, C), _(s, a, d, x, k), E(x), A(x), u)) {
                  let e = c.querySelectorAll(".ecom-image-zoom");
                  if (0 == e.length) return;
                  (L(e),
                    r &&
                      e.forEach(function (e) {
                        e.querySelector("a") &&
                          e
                            .querySelector("a")
                            .addEventListener("click", function (e) {
                              e.preventDefault();
                            });
                      }));
                }
              }
            }
            (k && "true" == k) ||
              (S &&
                "false" === x &&
                (C(S), l && l.addEventListener("ecomVariantChange", C)));
          })(),
        c
          .querySelectorAll(".ecom-product-single__media--play-control")
          .forEach(function (e) {
            e.addEventListener("click", function (e) {
              ((this.style.display = "none"),
                this.parentNode.querySelector("video").play());
            });
          }),
        !this.isLive)
      )
        try {
          n.$el.querySelectorAll("model-viewer").forEach(function (e) {
            const t = element.outerHTML;
            e.replaceWith(t);
          });
        } catch (e) {
          console.info(e.message);
        }
      if (
        document.querySelector("model-viewer") &&
        !document.getElementById("ModelViewerStyle")
      ) {
        let e = document.createElement("link");
        ((e.id = "ModelViewerStyle"),
          (e.rel = "stylesheet"),
          (e.href =
            "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"),
          (e.media = "print"),
          (e.onload = function () {
            this.media = "all";
          }),
          document.head.appendChild(e));
      }
      if (
        (window.Shopify &&
          window.Shopify.loadFeatures &&
          window.Shopify.loadFeatures([
            {
              name: "shopify-xr",
              version: "1.0",
              onLoad: function e() {
                if (window.ShopifyXR) {
                  try {
                    const e = n.$el.querySelector('[id^="Product-model-"]');
                    e &&
                      (window.ShopifyXR.addModels(JSON.parse(e.textContent)),
                      e.remove());
                  } catch (e) {
                    console.log(e.message);
                  }
                  window.ShopifyXR.setupXRElements();
                } else
                  document.addEventListener(
                    "shopify_xr_initialized",
                    function () {
                      e();
                    }
                  );
              }
            },
            {
              name: "model-viewer-ui",
              version: "1.0",
              onLoad: function (e) {
                if (e) return;
                const t = c.querySelectorAll("model-viewer");
                (t &&
                  t.forEach((e) => {
                    if (e)
                      try {
                        new window.Shopify.ModelViewerUI(e);
                      } catch (e) {
                        console.warn(e.message);
                      }
                  }),
                  c.querySelectorAll("button").forEach(function (e) {
                    e.setAttribute("type", "button");
                  }));
              }
            }
          ]),
        this.settings.image_action &&
          "lightbox" === this.settings.image_action &&
          r)
      ) {
        let e = this.$el.querySelectorAll("[ecom-modal]");
        e.length &&
          window.EComModal &&
          new window.EComModal(e, {
            gallery: !0,
            cssClass: ["ecom-container-lightbox-" + this.id]
          });
      }
      if (
        (this.settings.position_sticky &&
          window.innerWidth > 1024 &&
          c.parentElement &&
          (this.isLive
            ? (c.style.height = "100%")
            : (c.parentElement.style.height = "100%")),
        u)
      ) {
        let e = c.querySelectorAll(".ecom-image-zoom");
        if (0 == e.length) return;
        ("slider" !== d && L(e),
          r &&
            e.forEach(function (e) {
              e.querySelector("a") &&
                e.querySelector("a").addEventListener("click", function (e) {
                  e.preventDefault();
                });
            }));
      }
      function L(e) {
        if (r && !(window.innerWidth < 768) && window.EcomImgZoom)
          if (e.length > 0)
            for (var t = 0, o = e.length; t < o; t++)
              new window.EcomImgZoom(e[t], s);
          else new window.EcomImgZoom(e, s);
      }
    };
    document.querySelectorAll(".ecom-0wewrfjeno8i").forEach(function (t) {
      e.call({
        $el: t,
        id: "ecom-0wewrfjeno8i",
        settings: {
          show_thumbnails: !0,
          layout: "slider",
          thumbnail_position: "column",
          thumbnail_position__tablet: "column",
          thumbnail_position__mobile: "column",
          show_pagination: !1,
          image_action: "nothing"
        },
        isLive: !0
      });
    });
  })(),
  (function () {
    const e = function () {
      "use strict";
      ((window.__ectimmers = window.__ectimmers || {}),
        (window.__ectimmers["ecom-v3gttlhkkan"] =
          window.__ectimmers["ecom-v3gttlhkkan"] || {}));
      const e = this.$el;
      if (!e) return;
      const t = this.isLive,
        o =
          !!this.settings.show_option_selected &&
          this.settings.show_option_selected,
        i = !!this.settings.history_state && this.settings.history_state,
        n = this.settings.auto_variant_disable,
        c = this.settings.hide_soldout_variant,
        r = this.settings.hide_unavaiable_variant,
        s = this.settings.type,
        l = e.querySelector('[name="id"]'),
        a = e.closest(".ecom-product-form--single");
      if (!a) return;
      n && a.classList.add("ecom_auto_variant_disable");
      const d = e.querySelector(
        ".ecom-product-single__variant-picker-container"
      );
      let u = null;
      if (!l) return;
      const m = this.$el.querySelector("#" + l.dataset.jsonProduct);
      if (!m) return;
      let p = null;
      try {
        p = JSON.parse(m.innerHTML);
      } catch (e) {
        return;
      }
      function h(i) {
        ((function (e) {
          const t = a.querySelector(".ecom-product-single__price--badges");
          if (
            (t &&
              t.querySelectorAll("span").forEach(function (e) {
                e.style.display = "none";
              }),
            e)
          )
            if (e.available && e.price < e.compare_at_price) {
              if (
                t &&
                t.querySelector(".ecom-product-single__price--badges-sale")
              ) {
                const o = t.querySelector(
                  ".ecom-product-single__price--badges-sale"
                );
                o.style.display = "block";
                let i = 0;
                ((i = Math.round(
                  (100 * (e.compare_at_price - e.price)) / e.compare_at_price
                )),
                  "amount" === o.dataset.type &&
                    (i = window.EComposer.formatMoney(
                      e.compare_at_price - e.price
                    )));
                let n = o.dataset.text;
                ((n = n.replace(/\{.*\}/g, i)), (o.innerHTML = n));
              }
            } else
              e.available ||
                (t &&
                  (t.querySelector(
                    ".ecom-product-single__price--badges-sold-out"
                  ).style.display = "block"));
        })(i),
          (function (e) {
            const t = a.querySelectorAll(".ecom-product-single__media--slider");
            if (t.length && e)
              t.forEach(function (t) {
                var o, i;
                const n = t.querySelector(
                    ".ecom-product-single__media--featured"
                  ),
                  c = n.querySelector(
                    '.ecom-product-single__media--image[data-variant_id*="' +
                      e.id +
                      '"]'
                  );
                if (!c || "featured" === n.getAttribute("data-priority"))
                  return;
                const r = c.dataset.index;
                r !=
                  (null !=
                  (i =
                    null == (o = null == n ? void 0 : n.swiper)
                      ? void 0
                      : o.realIndex)
                    ? i
                    : 0) &&
                  n &&
                  n.swiper &&
                  n.swiper.slideTo(r, 200);
              });
            else if (e && e.featured_image) {
              const t = a.querySelector(".ecom-product-single__media--single");
              t &&
                t
                  .querySelector("img")
                  .setAttribute("src", e.featured_image.src);
            }
          })(i),
          (function (e) {
            const t = a.querySelectorAll(
              ".ecom-product-single__add-to-cart--submit"
            );
            t.length &&
              t.forEach(function (t) {
                if (a.classList.contains("ecom_auto_variant_disable") && n)
                  t.setAttribute("disabled", "disabled");
                else if (e)
                  e.available || null === e.inventory_management
                    ? (t.removeAttribute("disabled"),
                      t.querySelector(".ecom-add-to-cart-text") &&
                        (!e.inventory_management ||
                        (e.inventory_management && e.inventory_quantity > 0)
                          ? ((t.querySelector(
                              ".ecom-add-to-cart-text"
                            ).innerHTML = t.dataset.textAddCart),
                            t.classList.remove(
                              "ecom-product-single__pre-order"
                            ))
                          : e.inventory_quantity <= 0 &&
                            "continue" == e.inventory_policy &&
                            ((t.querySelector(
                              ".ecom-add-to-cart-text"
                            ).innerHTML = t.dataset.textPreOrder),
                            t.classList.add("ecom-product-single__pre-order"))))
                    : (t.setAttribute("disabled", "disabled"),
                      t.querySelector(".ecom-add-to-cart-text") &&
                        ((t.querySelector(".ecom-add-to-cart-text").innerHTML =
                          t.dataset.textOutstock),
                        t.classList.remove("ecom-product-single__pre-order")));
                else if (
                  (t.setAttribute("disabled", "disabled"),
                  t.querySelector(".ecom-add-to-cart-text"))
                ) {
                  let e = !1;
                  (d
                    .querySelectorAll(".single-option-selector")
                    .forEach(function (t) {
                      "" !== t.value || (e = !0);
                    }),
                    (t.querySelector(".ecom-add-to-cart-text").innerHTML = e
                      ? t.dataset.textAddCart
                      : t.dataset.textUnavailable));
                }
              });
          })(i),
          (function (e) {
            const t = a.querySelector(".ecom-product-single__quantity-input"),
              o = t && t.dataset.minValue ? parseInt(t.dataset.minValue) : "",
              i = t && t.dataset.maxValue ? parseInt(t.dataset.maxValue) : "";
            if (t) {
              if (!e)
                return (
                  (t.value = o && o > 0 ? o : 1),
                  void t.setAttribute("disabled", "disabled")
                );
              e.available
                ? ((!t.value || (o && o > 0 && t.value < o)) && (t.value = o),
                  t.removeAttribute("disabled", "disabled"))
                : (o && o > 0 && (t.value = o),
                  t.setAttribute("disabled", "disabled"));
              const n = e.inventory_quantity,
                c = e.inventory_policy;
              let r = i && i > 0 ? i : 9999;
              (e.inventory_management &&
                "deny" === c &&
                ((r = i && i > 0 && i < n ? i : n),
                (n < o || !t.value || (o && o > 0 && t.value < o)) &&
                  (t.value = o)),
                n < 1 &&
                  "continue" == c &&
                  ((!t.value || (o && o > 0 && t.value < o)) && (t.value = o),
                  (r = i && i > 0 ? i : 999999)),
                ((e && n && n > o) || (e && "continue" == c)) &&
                  (e.inventory_management && "deny" === c
                    ? (r = i && i > 0 && i < n ? i : n)
                    : e.inventory_management &&
                      "continue" === c &&
                      (r = i && i > 0 ? i : 999999),
                  t.value < o && (t.value = o)),
                r < 0 && (r = 0));
              let s = parseInt(t.value);
              (!o && s > r && (s = r),
                (s = isNaN(s) || !s ? 1 : s),
                !o && !e.available && (s = 0),
                (s = s >= 0 ? s : 1),
                (t.value = s),
                t.setAttribute("max", r));
            }
          })(i),
          (function (e) {
            if (
              (!a.classList.contains("ecom_auto_variant_disable") || !n) &&
              e &&
              e.options.length
            )
              for (let t = 0; t < e.options.length; t++)
                (a
                  .querySelectorAll(
                    `.ecom-product-single__swatch-item[data-option-index="${t}"][data-value="${e.options[t].replace(/'/g, "'").replace(/"/g, '\\"')}"]`
                  )
                  .forEach((e) => {
                    (e.parentNode.childNodes.forEach(function (e) {
                      e.classList &&
                        (e.classList.remove("ecom-box-active"),
                        e.classList.remove("ecom-button-active"),
                        e.classList.remove("ecom-image-active"));
                    }),
                      e.classList.add("ecom-box-active"),
                      e.classList.add("ecom-button-active"),
                      e.classList.add("ecom-image-active"));
                  }),
                  a
                    .querySelectorAll(
                      `select.ecom-product-single__swatch-select[data-option-index="${t}"]`
                    )
                    .forEach(function (o) {
                      o.value = e.options[t];
                    }));
          })(i),
          (function (e) {
            const t = a.querySelectorAll(
                ".ecom-product-single__price--regular"
              ),
              o = a.querySelectorAll(".ecom-product-single__price--sale"),
              i = a.querySelectorAll(
                ".ecom-product-single__price--badges-pecent-wrapper"
              ),
              n = a.querySelectorAll(".ecom-product_ground-price"),
              c = a.querySelector(".ecom-unit-price"),
              r = a.querySelectorAll(
                ".ecom-ground-price_unit-price-measurement"
              );
            var s;
            e &&
              (a.querySelector("shopify-payment-terms") &&
                a
                  .querySelector("shopify-payment-terms")
                  .setAttribute("variant-id", e.id),
              o.length &&
                ((s = e),
                o.forEach(function (e) {
                  (!s.compare_at_price || s.compare_at_price < s.price
                    ? e.classList.add("ecom-product-single__price-normal")
                    : e.classList.remove("ecom-product-single__price-normal"),
                    (e.innerHTML = window.EComposer.formatMoney(s.price)));
                })),
              i.length &&
                i.forEach(function (t) {
                  const o = t.dataset.labelType;
                  if (e.compare_at_price && e.compare_at_price > e.price) {
                    let i = Math.round(
                      ((e.compare_at_price - e.price) / e.compare_at_price) *
                        100
                    );
                    ("amount" === o &&
                      (i = window.EComposer.formatMoney(
                        e.compare_at_price - e.price
                      )),
                      t.querySelector("span") &&
                        ((t.style.display = "block"),
                        (t.querySelector("span").innerText = `-${i}%`)));
                  } else t.style.display = "none";
                }),
              t.length &&
                t.forEach(function (t) {
                  ((t.innerHTML = window.EComposer.formatMoney(
                    e.compare_at_price
                  )),
                    e.compare_at_price > e.price
                      ? (t.style.display = "inherit")
                      : (t.style.display = "none"));
                }),
              n.length &&
                (n.forEach(function (t) {
                  e.unit_price
                    ? ((t.style.display = "block"),
                      c && (c.style.display = "block"))
                    : ((t.style.display = "none"),
                      c && (c.style.display = "none"));
                  const o = t.querySelector(".ecom-ground-price_unit-price");
                  o &&
                    (o.innerHTML = window.EComposer.formatMoney(e.unit_price));
                }),
                r.length &&
                  r.forEach(function (t) {
                    1 != e.unit_price_measurement.reference_value
                      ? (t.innerHTML =
                          e.unit_price_measurement.reference_value +
                          e.unit_price_measurement.reference_unit)
                      : (t.innerHTML = e.unit_price_measurement.reference_unit);
                  })));
          })(i),
          (function (e) {
            const o = a.querySelector(".ecom-product-single__countdown");
            o &&
              e &&
              (t || (o.firstElementChild.style.display = ""),
              "true" === o.dataset.showOnSale
                ? e.compare_at_price > e.price && e.available
                  ? ((o.style.display = "inherit"),
                    o.classList.remove("ecom-placeholder-on-builder-mode"))
                  : (t && (o.style.display = "none"),
                    o.classList.add("ecom-placeholder-on-builder-mode"),
                    o.classList.add("ecom-force-show"),
                    (o.dataset.ecomPlaceholder =
                      "This feature not match with your condition"),
                    t || (o.firstElementChild.style.display = "none"))
                : (o.classList.remove("ecom-placeholder-on-builder-mode"),
                  (o.style.display = "inherit")));
          })(i),
          (function (e) {
            const t = a.querySelector(
                ".ecom-product-single__variant-attributes--barcode"
              ),
              o = a.querySelector(
                ".ecom-product-single__variant-attributes--sku"
              );
            e
              ? (t &&
                  (t.style.removeProperty("display"),
                  (t.querySelector(
                    ".ecom-product-single__variant-attributes--text"
                  ).innerHTML = "" + (e.barcode ? e.barcode : "N/A"))),
                o &&
                  (o.style.removeProperty("display"),
                  (o.querySelector(
                    ".ecom-product-single__variant-attributes--text"
                  ).innerHTML = "" + (e.sku ? e.sku : "N/A"))))
              : (t && (t.style.display = "none"),
                o && (o.style.display = "none"));
          })(i),
          (function (t) {
            if (!d || !t) return !1;
            (l.dispatchEvent(new Event("change")),
              d
                .querySelectorAll(
                  ".ecom-product-single__variant-picker--selected-value"
                )
                .forEach(function (e) {
                  e.remove();
                }),
              n &&
                a.classList.contains("ecom_auto_variant_disable") &&
                (a.classList.remove("ecom_auto_variant_disable"),
                a
                  .querySelectorAll(".ecom-product-single__add-to-cart--submit")
                  .forEach(function (e) {
                    e.removeAttribute("disabled");
                  })));
            const i = e.querySelectorAll(
              '.selector-wrapper label[for*="ecom-variant-selector"'
            );
            if (
              (i.length > 0 &&
                i.forEach((e) => {
                  const t = e.textContent;
                  e.childNodes.length && e.childNodes[0].remove();
                  const o = document.createElement("span");
                  ((o.className = "ecom-product-variant--option-label-text"),
                    (o.innerText = `${t}${t.endsWith(":") ? "" : ":"}`),
                    e.prepend(o));
                }),
              !o)
            )
              return 1;
            const c = t.options.length,
              r = d.querySelectorAll(".selector-wrapper");
            for (let e = 0; e < c; e++)
              (r[e] &&
                r[e].querySelectorAll("label").forEach((o) => {
                  const i = document.createElement("span");
                  ((i.className =
                    "ecom-product-single__variant-picker--selected-value"),
                    (i.innerHTML = t.options[e]),
                    o.appendChild(i));
                }),
                d
                  .querySelectorAll(
                    `.ecom-product-single__picker--option-label[data-option-index="${e}"]`
                  )
                  .forEach(function (o) {
                    let i = document.createElement("span");
                    (i.classList.add(
                      "ecom-product-single__variant-picker--selected-value"
                    ),
                      (i.innerHTML = t.options[e]),
                      o.appendChild(i));
                  }));
          })(i),
          (function (e) {
            const t = a.querySelectorAll(".ecom-product-single__media-label");
            e &&
              t.length &&
              t.forEach(function (t) {
                const o = t.querySelector(
                  "span.ecom-product-single__media-label-sale"
                );
                o &&
                  (o.style.display =
                    e.available &&
                    e.compare_at_price &&
                    e.compare_at_price > e.price
                      ? "block"
                      : "none");
                const i = t.querySelector(
                  ".ecom-product-single__media-label-sold-out"
                );
                i && (i.style.display = e.available ? "none" : "block");
                const n = t.querySelector(
                  ".ecom-product-single__media-label--bage-sale"
                );
                if (n) {
                  const t = n.dataset.labelType;
                  if (e.compare_at_price > e.price) {
                    let o = n.dataset.sale,
                      i = "";
                    ("amount" === t
                      ? ((i = e.compare_at_price - e.price),
                        (n.style.display = "inherit"),
                        (n.innerHTML = o.replace(
                          /\[.*\]/g,
                          window.EComposer.formatMoney(i)
                        )))
                      : ((i = Math.round(
                          (100 * (e.compare_at_price - e.price)) /
                            e.compare_at_price
                        )),
                        (n.style.display = "inherit"),
                        (n.innerHTML = o.replace(/\[.*\]/g, Math.floor(i)))),
                      (n.style.display = e.available ? "inherit" : "none"));
                  } else n.style.display = "none";
                }
              });
          })(i));
        const c = new CustomEvent("ecomVariantChange", {
          detail: { variant: i }
        });
        a.dispatchEvent(c);
      }
      if (
        (!l ||
          !l.classList.contains(
            "ecom-product-single__picker-default-variant"
          )) &&
        window.EComposer &&
        window.EComposer.OptionSelectors
      ) {
        let e = function () {
            const e = o.product.getVariantById(l.value);
            e && h(e);
          },
          t = function (e, t) {
            let o = null;
            if (2 === p.options.length) {
              const i = 0 === e ? 1 : 0,
                n = a.querySelector(
                  `.ecom-product-single__swatch-item.ecom-button-active[data-option-index="${i}"]`
                ),
                c = n ? n.dataset.value : null;
              if (!c) return;
              const r =
                0 === i
                  ? p.variants.find((e) => e.option1 === c && e.option2 === t)
                  : p.variants.find((e) => e.option2 === c && e.option1 === t);
              o = r && r.featured_image ? r.featured_image.src : null;
            }
            return o;
          };
        const o = new window.EComposer.OptionSelectors(l.id, {
          product: p,
          onVariantSelected: h,
          enableHistoryState: i,
          autoVariantDisabled: n
        });
        (l.addEventListener("swatch", function (e) {
          o.selectVariant(e.target.value);
        }),
          l.addEventListener("ecomUpdate", function () {
            (clearTimeout(u), (u = setTimeout(e, 1e3)));
          }));
        const m = {};
        let w = null;
        const _ = function (e, o = !0) {
            switch (e) {
              case 0:
                var i = "root",
                  n = d.querySelectorAll(".single-option-selector")[0];
                break;
              case 1:
                ((i = d.querySelectorAll(".single-option-selector")[0].value),
                  (n = d.querySelectorAll(".single-option-selector")[1]));
                break;
              case 2:
                i = d.querySelectorAll(".single-option-selector")[0].value;
                i +=
                  " / " +
                  d.querySelectorAll(".single-option-selector")[1].value;
                n = d.querySelectorAll(".single-option-selector")[2];
            }
            if (!o) {
              const t = a.querySelector(`select[data-option-index="${e}"]`);
              if (
                t &&
                t.classList.contains(
                  "ecom-product-single__picker-dropdown-list"
                )
              )
                return;
            }
            if (n) {
              var l = n.value;
              n.innerHTML = "";
              var u = m[i] || [];
              if (u) {
                for (var p = 0; p < u.length; p++) {
                  var h = u[p],
                    f = document.createElement("option");
                  ((f.value = h), (f.innerHTML = h), n.append(f));
                }
                var _ = a.querySelector(
                  '.ecom-product-single__swatch-select[data-option-index="' +
                    e +
                    '"]'
                );
                (_ && (_.innerHTML = n.innerHTML),
                  a
                    .querySelectorAll(
                      '.ecom-product-single__swatch-item[data-option-index="' +
                        e +
                        '"]'
                    )
                    .forEach((o) => {
                      var i = o.dataset.value;
                      if ("image" === s && o.querySelector("img")) {
                        const n = t(e, i);
                        n && o.querySelector("img").setAttribute("src", n);
                      }
                      (c || r) &&
                        (i && -1 !== u.indexOf(i)
                          ? o.classList.remove("ecom-variant-disable")
                          : o.classList.add("ecom-variant-disable"));
                    }),
                  -1 !== u.indexOf(l) && (n.value = l),
                  clearTimeout(w),
                  (w = setTimeout(() => {
                    o && n.dispatchEvent(new Event("change"));
                  }, 50)));
              }
            }
          },
          g = function (e) {
            for (var t = 0; t < e.variants.length; t++) {
              var o = e.variants[t];
              if (!c || o.available) {
                if (
                  ((m.root = m.root || []),
                  m.root.push(o.option1),
                  (m.root = EComposer.uniq(m.root)),
                  e.options.length > 1)
                ) {
                  var i = o.option1;
                  ((m[i] = m[i] || []),
                    m[i].push(o.option2),
                    (m[i] = EComposer.uniq(m[i])));
                }
                if (3 === e.options.length) {
                  i = o.option1 + " / " + o.option2;
                  ((m[i] = m[i] || []),
                    m[i].push(o.option3),
                    (m[i] = EComposer.uniq(m[i])));
                }
              }
            }
            (_(0, o),
              e.options.length > 1 && _(1),
              3 === e.options.length && _(2));
            var n = d.querySelectorAll(".single-option-selector")[0];
            n &&
              n.addEventListener("change", function (t) {
                return (
                  e.options.length > 1 && _(1),
                  3 === e.options.length && _(2),
                  !0
                );
              });
            var r = d.querySelectorAll(".single-option-selector")[1];
            r &&
              r.addEventListener("change", function (t) {
                return (_(0, !1), 3 === e.options.length && _(2), !0);
              });
          };
        if (window.MutationObserver && a && ("image" === s || c || r)) {
          "object" == typeof f &&
            "function" == typeof f.disconnect &&
            f.disconnect();
          var f = new MutationObserver(function () {
            (g(p), f.disconnect());
          });
          f.observe(a, { childList: !0, subtree: !0 });
        }
      }
      if (
        !this.settings.hasOwnProperty("show_option_selected") &&
        !this.settings.show_option_selected
      ) {
        const t = e.querySelectorAll(
          '.selector-wrapper label[for*="ecom-variant-selector"'
        );
        t.length > 0 &&
          t.forEach((e) => {
            const t = e.textContent;
            e.childNodes.length && e.childNodes[0].remove();
            const o = document.createElement("span");
            ((o.className = "ecom-product-variant--option-label-text"),
              (o.innerText = t + ":"),
              e.prepend(o));
          });
      }
      (a
        .querySelectorAll(
          ".ecom-product-single__swatch-item[data-option-index]"
        )
        .forEach((e) => {
          e.addEventListener("click", function (e) {
            e.preventDefault();
            const o = a.querySelectorAll(
              ".ecom-product-single__media--featured"
            );
            let i = null;
            if (!o) return;
            (o.length > 1
              ? o.forEach(function (e, o) {
                  i ||
                    (t
                      ? ((window.screen.width > 1024 &&
                          !e.closest(".hide-on-desktop")) ||
                          (window.screen.width > 767 &&
                            window.screen.width <= 1024 &&
                            !e.closest(".hide-on-tablet")) ||
                          (window.screen.width <= 767 &&
                            !e.closest(".hide-on-mobile"))) &&
                        (i = e)
                      : ((window.innerWidth > 1024 &&
                          !e.closest(".hide-on-desktop")) ||
                          (window.innerWidth > 767 &&
                            window.innerWidth <= 1024 &&
                            !e.closest(".hide-on-tablet")) ||
                          (window.innerWidth <= 767 &&
                            !e.closest(".hide-on-mobile"))) &&
                        (i = e));
                })
              : (i = o[0]),
              i && i.removeAttribute("data-priority"));
            const n = this;
            if (
              this.classList.contains("ecom-button-active") &&
              this.classList.contains("ecom-image-button")
            )
              return;
            (this.parentNode.childNodes.forEach(function (e) {
              e.classList &&
                (e.classList.remove("ecom-button-active"),
                e.classList.remove("ecom-image-button"));
            }),
              this.classList.add("ecom-button-active"),
              this.classList.add("ecom-image-button"));
            const c = this.dataset.optionIndex;
            (a.classList.remove("ecom_auto_variant_disable"),
              a
                .querySelectorAll("select#" + l.id + "-option-" + c)
                .forEach(function (e) {
                  ((e.value = n.dataset.value),
                    e.dispatchEvent(new Event("change")));
                }));
          });
        }),
        a.querySelectorAll(".ecom-product-single__swatch-select").length
          ? a
              .querySelectorAll(".ecom-product-single__swatch-select")
              .forEach(function (e) {
                e.addEventListener("change", function (e) {
                  const t = a.querySelectorAll(
                    ".ecom-product-single__media--featured"
                  );
                  let o = null;
                  if (!t) return;
                  (t.length > 1
                    ? t.forEach(function (e, t) {
                        o ||
                          (((window.screen.width > 1024 &&
                            !e.closest(".hide-on-desktop")) ||
                            (window.screen.width > 767 &&
                              window.screen.width <= 1024 &&
                              !e.closest(".hide-on-tablet")) ||
                            (window.screen.width <= 767 &&
                              !e.closest(".hide-on-mobile"))) &&
                            (o = e));
                      })
                    : (o = t[0]),
                    o && o.removeAttribute("data-priority"));
                  let i = e.target.getAttribute("data-option-index"),
                    n = e.target.value;
                  (a.classList.remove("ecom_auto_variant_disable"),
                    a
                      .querySelectorAll("select#" + l.id + "-option-" + i)
                      .forEach(function (e) {
                        ((e.value = n), e.dispatchEvent(new Event("change")));
                      }));
                });
              })
          : setTimeout(
              function () {
                const e = a.querySelectorAll(
                  ".ecom-product-single__media--featured"
                );
                let t = null;
                !e ||
                  (e.length > 1
                    ? e.forEach(function (e, o) {
                        t ||
                          (((window.screen.width > 1024 &&
                            !e.closest(".hide-on-desktop")) ||
                            (window.screen.width > 767 &&
                              window.screen.width <= 1024 &&
                              !e.closest(".hide-on-tablet")) ||
                            (window.screen.width <= 767 &&
                              !e.closest(".hide-on-mobile"))) &&
                            (t = e));
                      })
                    : (t = e[0]),
                  t && t.removeAttribute("data-priority"));
              },
              t ? 500 : 2500
            ));
    };
    document.querySelectorAll(".ecom-v3gttlhkkan").forEach(function (t) {
      e.call({
        $el: t,
        id: "ecom-v3gttlhkkan",
        settings: {
          show_option_selected: !0,
          hide_unavaiable_variant: !1,
          type: "color"
        },
        isLive: !0
      });
    });
  })(),
  window.addEventListener("load", () => {
    let e = !1;
    if ((document.querySelector("#admin-bar-iframe") && (e = !0), !e)) {
      if (window.EComposerBrand) return;
      window.EComposerBrand = !0;
    }
    let t = document.querySelector("body"),
      o = document.createElement(
        Math.random().toString(36).replace(/\d*/g, "").substr(2, 4)
      );
    (o.setAttribute(
      "style",
      [
        "position:relative",
        "top: 0px",
        "left: 0px",
        "display: inline-block",
        "height: 30px",
        "line-height: 30px",
        "font-size: 11px",
        "width: 100%",
        "text-align: center",
        "opacity: 1",
        "text-indent: 0",
        "color: rgba(18, 18, 18, 0.75)",
        "background: transparent",
        "opacity: 0.8",
        ""
      ].join(" !important;")
    ),
      (o.innerHTML =
        "Built with <a style='color: currentColor;text-decoration: none;' href=\"https://ecomposer.io/?utm_source=client-site&utm_medium=footer&utm_campaign=footer_branding&utm_term=links&utm_content=" +
        window.location.origin +
        '" target="_blank">EComposer</a>' +
        (e ? ". Contact us or upgrade to remove branding" : "")),
      t.appendChild(o));
  }));
